(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VAIMISUtilityV2", [], factory);
	else if(typeof exports === 'object')
		exports["VAIMISUtilityV2"] = factory();
	else
		root["VAIMISUtilityV2"] = factory();
})(self, function() {
return 